// extracted by mini-css-extract-plugin
module.exports = {"container":"switchButton_container__2-rYD","toggleBlock":"switchButton_toggleBlock__2omp-","toggle":"switchButton_toggle__IEZ_w","toggled":"switchButton_toggled__1ilZb","label":"switchButton_label__1mSN5"};
    if(module.hot) {
      // 1745223433487
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  